module.exports = __webpack_public_path__ + "img/gb-whatsapp-setup-after-install.f21cc687.png";